import { PrintingActivityItemResponse } from '@/types/service-response'
import moment from 'moment'

export class PrintingActivity {
  public constructor (
    readonly id: number,
    readonly printSpoolerId: number,
    readonly formular: string | null,
    readonly personalNummer: string | null,
    readonly mitarbeiter: string | null,
    readonly belegnummer: string | null,
    readonly priority: number | null,
    readonly druckSpracheCode: string | null,
    readonly nurPDF: boolean,
    readonly jobDatum: string | null,
    readonly jobStatus: number,
    readonly jobStatusBezeichnung: string | null,
    readonly fehler: boolean,
    readonly fehlerbezeichnung: string | null,
  ) {}

  static createListFromResponse (responseData: PrintingActivityItemResponse[]): PrintingActivity[] {
    let result: PrintingActivity[] = []
    if (responseData) {
      result = responseData.map((item: PrintingActivityItemResponse ) => {
        return new PrintingActivity(
          item.ID,
          item.PrintSpoolerID,
          item.Formular,
          item.PersonalNummer,
          item.Mitarbeiter,
          item.Belegnummer,
          item.Priority,
          item.DruckSpracheCode,
          item.Nur_PDF,
          item.JobDatum ? moment(item.JobDatum). format('DD.MM.YYYY HH:mm') : null,
          item.JobStatus,
          item.JobStatusBezeichnung,
          item.Fehler,
          item.Fehlerbezeichnung
        )
      })
    }
    return result
  }
}
